import { DialogueData } from '../../atoms/dialogue';

const dialogue_puzzle2_02: DialogueData = {
	name: 'Dispatch',
	messages: { 
		
		// start message         
		'dialogue_puzzle2_02_00':{
			speakingCharacter: 0,
			followupMessage: 'dialogue_puzzle2_02_01'
		},
		'dialogue_puzzle2_02_01':{
			speakingCharacter: 0,
		},
	}
};

export default dialogue_puzzle2_02;